import type { Epic } from '../../index.js'
import { Actions } from '../../Slice/index.js'
import { visualizationSlice } from '../../Slice/Visualization/VisualizationSlice.js'
import { catchError, filter, map, mergeMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { listWorkspaceStates } from '../../../Repository/Visualization/WorkspaceStates.js'

export const listRemoteViewsEpic: Epic = (action$) => {
  const v = Actions[visualizationSlice.name]

  return action$.pipe(
    filter(v.remoteListRequest.match),
    mergeMap((action) => {
      const scopeId = action.payload.scopeId
      if (!scopeId) return of(v.remoteListFailure({ error: 'No scope' }))

      // repo returns Observable — no from()
      return listWorkspaceStates(scopeId).pipe(
        map((items) =>
          v.remoteListSuccess({
            items: items.map((it) => ({
              id: it.id,
              name: it.name,
              comment: it.comment,
              isTemplate: it.isTemplate,
              isShared: it.isShared,
              schemaVersion: it.schemaVersion,
              createdAt: it.createdAt,
              modifiedAt: it.modifiedAt,
              lastUsedAt: it.lastUsedAt
            }))
          })
        ),
        catchError((e) => of(v.remoteListFailure({ error: String(e) })))
      )
    })
  )
}
